













































import {Component, Vue} from 'vue-property-decorator';
import HeroImage from '@/components/Views/Home Page/HeroImage.vue';

@Component({
    components: {},
})
export default class ServicesDirectory extends Vue {
    public blocks = [
        {icon: 'fas fa-cut', header: 'Hair', text: 'Professional Hairdressers that are ready at a moment\'s notice to give you the style you want, when you want it.'},
        {icon: 'fas fa-kiss-wink-heart', header: 'Makeup', text: 'No need to spend hours applying makeup. Let a SoPlush Makeup Artist perfect it as you like.'},
        {icon: 'fas fa-heart', header: 'Weddings', text: 'Your wedding will be one the most important days of your life. We understand that better than anyone.'},
        {icon: 'fas fa-glass-cheers', header: 'Events', text: 'Whether it\'s prom, work-related events, or just a night out, we\'ve got you fully covered!'},
    ];

    public services = [
        {path: '/services/hair-and-makeup-services', header: 'Hair & Makeup Services', priceRange: '$50 - $350', image: '5cf1baa0c45cc623910df221.jpg'},
        {path: '/services/hair-services', header: 'Hair Services', priceRange: '$50 - $350', image: '5cf1baa0c45cc623910df236.jpg'},
        {path: '/services/makeup-services', header: 'Makeup Services', priceRange: '$50 - $350', image: '5cf1baa0c45cc623910df243.jpg'},
    ];

}
